// src/lib/senateData2024.js
// 2024 Senate Election Results - 11 States with County-Level Data

export const senateResults2024 = [
  // Florida
  {
    state: "FL",
    demCandidate: "Debbie Mucarsel-Powell",
    repCandidate: "Rick Scott",
    indCandidate: null,
    demVotes: 4603077,
    repVotes: 5977706,
    indVotes: 0,
    otherVotes: 62683,
    totalVotes: 10757415,
    winner: "R",
    incumbent: "R",
    counties: [
      { county: "Miami-Dade", margin: 10, marginParty: "R", totalVotes: 1076112 },
      { county: "Broward", margin: 20, marginParty: "D", totalVotes: 862675 },
      { county: "Palm Beach", margin: 1.7, marginParty: "D", totalVotes: 734239 },
      { county: "Hillsborough", margin: 3, marginParty: "R", totalVotes: 665321 },
      { county: "Orange", margin: 12, marginParty: "D", totalVotes: 600562 },
      { county: "Pinellas", margin: 4, marginParty: "R", totalVotes: 511504 },
      { county: "Duval", margin: 1.9, marginParty: "R", totalVotes: 463682 },
      { county: "Lee", margin: 34, marginParty: "R", totalVotes: 385311 },
      { county: "Brevard", margin: 19, marginParty: "R", totalVotes: 357638 },
      { county: "Polk", margin: 19, marginParty: "R", totalVotes: 343311 },
      { county: "Pasco", margin: 21, marginParty: "R", totalVotes: 313646 },
      { county: "Volusia", margin: 19, marginParty: "R", totalVotes: 306603 },
      { county: "Sarasota", margin: 18, marginParty: "R", totalVotes: 275417 },
      { county: "Seminole", margin: 4, marginParty: "R", totalVotes: 250526 },
      { county: "Manatee", margin: 23, marginParty: "R", totalVotes: 226668 },
      { county: "Lake", margin: 24, marginParty: "R", totalVotes: 223857 },
      { county: "Collier", margin: 40, marginParty: "R", totalVotes: 215583 },
      { county: "Marion", margin: 30, marginParty: "R", totalVotes: 211415 },
      { county: "St. Johns", margin: 33, marginParty: "R", totalVotes: 195631 },
      { county: "St. Lucie", margin: 6, marginParty: "R", totalVotes: 182716 },
      { county: "Osceola", margin: 2, marginParty: "R", totalVotes: 170324 },
      { county: "Escambia", margin: 24, marginParty: "R", totalVotes: 161721 },
      { county: "Leon", margin: 16, marginParty: "D", totalVotes: 155081 },
      { county: "Alachua", margin: 18, marginParty: "D", totalVotes: 135208 },
      { county: "Clay", margin: 39, marginParty: "R", totalVotes: 125775 },
      { county: "Charlotte", margin: 36, marginParty: "R", totalVotes: 122211 },
      { county: "Okaloosa", margin: 46, marginParty: "R", totalVotes: 112603 },
      { county: "Santa Rosa", margin: 54, marginParty: "R", totalVotes: 111532 },
      { county: "Hernando", margin: 31, marginParty: "R", totalVotes: 109030 },
      { county: "Sumter", margin: 39, marginParty: "R", totalVotes: 104582 },
      { county: "Indian River", margin: 26, marginParty: "R", totalVotes: 97781 },
      { county: "Martin", margin: 29, marginParty: "R", totalVotes: 97207 },
      { county: "Bay", margin: 51, marginParty: "R", totalVotes: 97065 },
      { county: "Citrus", margin: 40, marginParty: "R", totalVotes: 96877 },
      { county: "Flagler", margin: 27, marginParty: "R", totalVotes: 78913 },
      { county: "Nassau", margin: 47, marginParty: "R", totalVotes: 65317 },
      { county: "Highlands", margin: 37, marginParty: "R", totalVotes: 51259 },
      { county: "Walton", margin: 59, marginParty: "R", totalVotes: 49199 },
      { county: "Monroe", margin: 16, marginParty: "R", totalVotes: 43771 },
      { county: "Putnam", margin: 45, marginParty: "R", totalVotes: 35828 },
      { county: "Columbia", margin: 49, marginParty: "R", totalVotes: 33219 },
      { county: "Levy", margin: 50, marginParty: "R", totalVotes: 24111 },
      { county: "Jackson", margin: 48, marginParty: "R", totalVotes: 21963 },
      { county: "Gadsden", margin: 23, marginParty: "D", totalVotes: 21746 },
      { county: "Suwannee", margin: 60, marginParty: "R", totalVotes: 21657 },
      { county: "Wakulla", margin: 45, marginParty: "R", totalVotes: 19650 },
      { county: "Okeechobee", margin: 48, marginParty: "R", totalVotes: 15790 },
      { county: "Baker", margin: 69, marginParty: "R", totalVotes: 14797 },
      { county: "Bradford", margin: 54, marginParty: "R", totalVotes: 13617 },
      { county: "Hendry", margin: 41, marginParty: "R", totalVotes: 13256 },
      { county: "Washington", margin: 66, marginParty: "R", totalVotes: 12515 },
      { county: "DeSoto", margin: 43, marginParty: "R", totalVotes: 12311 },
      { county: "Gilchrist", margin: 67, marginParty: "R", totalVotes: 10564 },
      { county: "Taylor", margin: 62, marginParty: "R", totalVotes: 9893 },
      { county: "Madison", margin: 33, marginParty: "R", totalVotes: 9079 },
      { county: "Holmes", margin: 79, marginParty: "R", totalVotes: 9061 },
      { county: "Gulf", margin: 58, marginParty: "R", totalVotes: 8648 },
      { county: "Jefferson", margin: 22, marginParty: "R", totalVotes: 8455 },
      { county: "Hardee", margin: 51, marginParty: "R", totalVotes: 8058 },
      { county: "Dixie", margin: 69, marginParty: "R", totalVotes: 8002 },
      { county: "Franklin", margin: 45, marginParty: "R", totalVotes: 6724 },
      { county: "Calhoun", margin: 68, marginParty: "R", totalVotes: 6369 },
      { county: "Union", margin: 64, marginParty: "R", totalVotes: 6151 },
      { county: "Hamilton", margin: 41, marginParty: "R", totalVotes: 5660 },
      { county: "Glades", margin: 54, marginParty: "R", totalVotes: 5242 },
      { county: "Lafayette", margin: 73, marginParty: "R", totalVotes: 3724 },
      { county: "Liberty", margin: 67, marginParty: "R", totalVotes: 3452 }
    ]
  },

  // Pennsylvania
  {
    state: "PA",
    demCandidate: "Bob Casey",
    repCandidate: "Dave McCormick",
    indCandidate: null,
    demVotes: 3384180,
    repVotes: 3399295,
    indVotes: 0,
    otherVotes: 89653,
    totalVotes: 6963137,
    winner: "R",
    incumbent: "D",
    counties: [
      { county: "Allegheny", margin: 21, marginParty: "D", totalVotes: 715922 },
      { county: "Philadelphia", margin: 60, marginParty: "D", totalVotes: 690316 },
      { county: "Montgomery", margin: 22, marginParty: "D", totalVotes: 519968 },
      { county: "Bucks", margin: 0.56, marginParty: "D", totalVotes: 399833 },
      { county: "Delaware", margin: 23, marginParty: "D", totalVotes: 326457 },
      { county: "Chester", margin: 12, marginParty: "D", totalVotes: 324655 },
      { county: "Lancaster", margin: 15, marginParty: "R", totalVotes: 288352 },
      { county: "York", margin: 23, marginParty: "R", totalVotes: 247928 },
      { county: "Westmoreland", margin: 25, marginParty: "R", totalVotes: 208937 },
      { county: "Berks", margin: 9, marginParty: "R", totalVotes: 203642 },
      { county: "Lehigh", margin: 4, marginParty: "D", totalVotes: 187584 },
      { county: "Northampton", margin: 0.59, marginParty: "R", totalVotes: 174615 },
      { county: "Luzerne", margin: 15, marginParty: "R", totalVotes: 155090 },
      { county: "Dauphin", margin: 7, marginParty: "D", totalVotes: 148956 },
      { county: "Cumberland", margin: 9, marginParty: "R", totalVotes: 147403 },
      { county: "Erie", margin: 1.7, marginParty: "D", totalVotes: 136842 },
      { county: "Butler", margin: 30, marginParty: "R", totalVotes: 120967 },
      { county: "Washington", margin: 21, marginParty: "R", totalVotes: 120441 },
      { county: "Lackawanna", margin: 8, marginParty: "D", totalVotes: 115886 },
      { county: "Beaver", margin: 16, marginParty: "R", totalVotes: 94757 },
      { county: "Monroe", margin: 0.97, marginParty: "D", totalVotes: 85028 },
      { county: "Franklin", margin: 40, marginParty: "R", totalVotes: 83121 },
      { county: "Centre", margin: 3, marginParty: "D", totalVotes: 80415 },
      { county: "Lebanon", margin: 29, marginParty: "R", totalVotes: 73139 },
      { county: "Schuylkill", margin: 36, marginParty: "R", totalVotes: 72840 },
      { county: "Cambria", margin: 33, marginParty: "R", totalVotes: 71004 },
      { county: "Blair", margin: 41, marginParty: "R", totalVotes: 64723 },
      { county: "Fayette", margin: 32, marginParty: "R", totalVotes: 62945 },
      { county: "Adams", margin: 31, marginParty: "R", totalVotes: 60276 },
      { county: "Lycoming", margin: 39, marginParty: "R", totalVotes: 59495 },
      { county: "Mercer", margin: 28, marginParty: "R", totalVotes: 58088 },
      { county: "Lawrence", margin: 28, marginParty: "R", totalVotes: 46792 },
      { county: "Northumberland", margin: 35, marginParty: "R", totalVotes: 43294 },
      { county: "Crawford", margin: 35, marginParty: "R", totalVotes: 42714 },
      { county: "Indiana", margin: 35, marginParty: "R", totalVotes: 42068 },
      { county: "Somerset", margin: 53, marginParty: "R", totalVotes: 40809 },
      { county: "Clearfield", margin: 47, marginParty: "R", totalVotes: 40212 },
      { county: "Armstrong", margin: 47, marginParty: "R", totalVotes: 36944 },
      { county: "Carbon", margin: 31, marginParty: "R", totalVotes: 35071 },
      { county: "Pike", margin: 23, marginParty: "R", totalVotes: 34609 },
      { county: "Columbia", margin: 30, marginParty: "R", totalVotes: 32375 },
      { county: "Bradford", margin: 46, marginParty: "R", totalVotes: 30910 },
      { county: "Wayne", margin: 34, marginParty: "R", totalVotes: 29335 },
      { county: "Bedford", margin: 65, marginParty: "R", totalVotes: 28043 },
      { county: "Venango", margin: 37, marginParty: "R", totalVotes: 26631 },
      { county: "Perry", margin: 46, marginParty: "R", totalVotes: 25680 },
      { county: "Jefferson", margin: 55, marginParty: "R", totalVotes: 23078 },
      { county: "Huntingdon", margin: 49, marginParty: "R", totalVotes: 23028 },
      { county: "Susquehanna", margin: 42, marginParty: "R", totalVotes: 22216 },
      { county: "Mifflin", margin: 52, marginParty: "R", totalVotes: 21946 },
      { county: "Tioga", margin: 50, marginParty: "R", totalVotes: 21432 },
      { county: "Union", margin: 23, marginParty: "R", totalVotes: 21072 },
      { county: "Warren", margin: 35, marginParty: "R", totalVotes: 20667 },
      { county: "Snyder", margin: 45, marginParty: "R", totalVotes: 19947 },
      { county: "Clarion", margin: 48, marginParty: "R", totalVotes: 19679 },
      { county: "McKean", margin: 44, marginParty: "R", totalVotes: 19571 },
      { county: "Clinton", margin: 35, marginParty: "R", totalVotes: 18448 },
      { county: "Greene", margin: 38, marginParty: "R", totalVotes: 17145 },
      { county: "Elk", margin: 42, marginParty: "R", totalVotes: 17089 },
      { county: "Wyoming", margin: 34, marginParty: "R", totalVotes: 15016 },
      { county: "Juniata", margin: 56, marginParty: "R", totalVotes: 12042 },
      { county: "Montour", margin: 21, marginParty: "R", totalVotes: 9900 },
      { county: "Potter", margin: 60, marginParty: "R", totalVotes: 9055 },
      { county: "Fulton", margin: 69, marginParty: "R", totalVotes: 8116 },
      { county: "Sullivan", margin: 43, marginParty: "R", totalVotes: 3715 },
      { county: "Forest", margin: 40, marginParty: "R", totalVotes: 2649 },
      { county: "Cameron", margin: 44, marginParty: "R", totalVotes: 2214 }
    ]
  },

  // Texas
  {
    state: "TX",
    demCandidate: "Colin Allred",
    repCandidate: "Ted Cruz",
    indCandidate: null,
    demVotes: 5031249,
    repVotes: 5990741,
    indVotes: 0,
    otherVotes: 267039,
    totalVotes: 11289029,
    winner: "R",
    incumbent: "R",
    counties: [
      { county: "Harris", margin: 11, marginParty: "D", totalVotes: 1548618 },
      { county: "Dallas", margin: 28, marginParty: "D", totalVotes: 842203 },
      { county: "Tarrant", margin: 0.22, marginParty: "D", totalVotes: 821255 },
      { county: "Bexar", margin: 16, marginParty: "D", totalVotes: 743875 },
      { county: "Travis", margin: 43, marginParty: "D", totalVotes: 578302 },
      { county: "Collin", margin: 5, marginParty: "R", totalVotes: 511133 },
      { county: "Denton", margin: 8, marginParty: "R", totalVotes: 448314 },
      { county: "Fort Bend", margin: 8, marginParty: "D", totalVotes: 356039 },
      { county: "Montgomery", margin: 41, marginParty: "R", totalVotes: 306454 },
      { county: "Williamson", margin: 1.5, marginParty: "D", totalVotes: 305936 },
      { county: "El Paso", margin: 20, marginParty: "D", totalVotes: 244897 },
      { county: "Hidalgo", margin: 7, marginParty: "D", totalVotes: 211597 },
      { county: "Brazoria", margin: 14, marginParty: "R", totalVotes: 161416 },
      { county: "Galveston", margin: 23, marginParty: "R", totalVotes: 158365 },
      { county: "Bell", margin: 12, marginParty: "R", totalVotes: 129340 },
      { county: "Hays", margin: 10, marginParty: "D", totalVotes: 125542 },
      { county: "Lubbock", margin: 37, marginParty: "R", totalVotes: 124453 },
      { county: "Nueces", margin: 6, marginParty: "R", totalVotes: 120459 },
      { county: "Cameron", margin: 4, marginParty: "D", totalVotes: 114499 },
      { county: "Comal", margin: 41, marginParty: "R", totalVotes: 103310 },
      { county: "Smith", margin: 42, marginParty: "R", totalVotes: 103209 },
      { county: "McLennan", margin: 26, marginParty: "R", totalVotes: 99722 },
      { county: "Ellis", margin: 26, marginParty: "R", totalVotes: 98754 },
      { county: "Brazos", margin: 21, marginParty: "R", totalVotes: 91709 },
      { county: "Parker", margin: 62, marginParty: "R", totalVotes: 90712 },
      { county: "Jefferson", margin: 5, marginParty: "R", totalVotes: 84931 },
      { county: "Guadalupe", margin: 24, marginParty: "R", totalVotes: 84087 },
      { county: "Johnson", margin: 45, marginParty: "R", totalVotes: 80310 },
      { county: "Kaufman", margin: 22, marginParty: "R", totalVotes: 68817 },
      { county: "Randall", margin: 57, marginParty: "R", totalVotes: 66873 },
      { county: "Grayson", margin: 51, marginParty: "R", totalVotes: 65268 },
      { county: "Webb", margin: 9, marginParty: "D", totalVotes: 63684 },
      { county: "Rockwall", margin: 36, marginParty: "R", totalVotes: 62319 },
      { county: "Midland", margin: 57, marginParty: "R", totalVotes: 58181 },
      { county: "Taylor", margin: 45, marginParty: "R", totalVotes: 55238 },
      { county: "Gregg", margin: 39, marginParty: "R", totalVotes: 46489 },
      { county: "Hunt", margin: 50, marginParty: "R", totalVotes: 46393 },
      { county: "Tom Green", margin: 43, marginParty: "R", totalVotes: 45165 },
      { county: "Wichita", margin: 41, marginParty: "R", totalVotes: 44243 },
      { county: "Ector", margin: 48, marginParty: "R", totalVotes: 42268 },
      { county: "Bastrop", margin: 14, marginParty: "R", totalVotes: 39436 },
      { county: "Henderson", margin: 59, marginParty: "R", totalVotes: 38218 },
      { county: "Wise", margin: 65, marginParty: "R", totalVotes: 38138 },
      { county: "Hood", margin: 62, marginParty: "R", totalVotes: 36457 },
      { county: "Bowie", margin: 46, marginParty: "R", totalVotes: 36191 },
      { county: "Orange", margin: 63, marginParty: "R", totalVotes: 35953 },
      { county: "Victoria", margin: 40, marginParty: "R", totalVotes: 34828 },
      { county: "Angelina", margin: 49, marginParty: "R", totalVotes: 34063 },
      { county: "Potter", margin: 41, marginParty: "R", totalVotes: 31878 },
      { county: "Liberty", margin: 57, marginParty: "R", totalVotes: 31048 },
      { county: "Harrison", margin: 49, marginParty: "R", totalVotes: 30018 },
      { county: "Kendall", margin: 53, marginParty: "R", totalVotes: 29277 },
      { county: "Kerr", margin: 50, marginParty: "R", totalVotes: 28112 },
      { county: "Burnet", margin: 52, marginParty: "R", totalVotes: 28081 },
      { county: "Hardin", margin: 73, marginParty: "R", totalVotes: 28068 },
      { county: "Van Zandt", margin: 71, marginParty: "R", totalVotes: 27920 },
      { county: "Waller", margin: 22, marginParty: "R", totalVotes: 27437 },
      { county: "Wilson", margin: 48, marginParty: "R", totalVotes: 27129 },
      { county: "Nacogdoches", margin: 36, marginParty: "R", totalVotes: 25467 },
      { county: "San Patricio", margin: 30, marginParty: "R", totalVotes: 25318 },
      { county: "Walker", margin: 36, marginParty: "R", totalVotes: 24977 },
      { county: "Chambers", margin: 61, marginParty: "R", totalVotes: 24871 },
      { county: "Medina", margin: 37, marginParty: "R", totalVotes: 24448 },
      { county: "Wood", margin: 67, marginParty: "R", totalVotes: 24318 },
      { county: "Polk", margin: 56, marginParty: "R", totalVotes: 24138 },
      { county: "Coryell", margin: 36, marginParty: "R", totalVotes: 23771 },
      { county: "Rusk", margin: 57, marginParty: "R", totalVotes: 21521 },
      { county: "Lamar", margin: 57, marginParty: "R", totalVotes: 21106 },
      { county: "Cherokee", margin: 60, marginParty: "R", totalVotes: 20391 },
      { county: "Cooke", margin: 62, marginParty: "R", totalVotes: 20292 },
      { county: "Upshur", margin: 68, marginParty: "R", totalVotes: 19836 },
      { county: "Navarro", margin: 47, marginParty: "R", totalVotes: 19792 },
      { county: "Anderson", margin: 58, marginParty: "R", totalVotes: 19211 },
      { county: "Erath", margin: 64, marginParty: "R", totalVotes: 18178 },
      { county: "Atascosa", margin: 34, marginParty: "R", totalVotes: 18157 },
      { county: "Washington", margin: 52, marginParty: "R", totalVotes: 18140 },
      { county: "Brown", margin: 70, marginParty: "R", totalVotes: 16780 },
      { county: "Hopkins", margin: 61, marginParty: "R", totalVotes: 16705 },
      { county: "Hill", margin: 59, marginParty: "R", totalVotes: 16654 },
      { county: "Gillespie", margin: 58, marginParty: "R", totalVotes: 16506 },
      { county: "Fannin", margin: 62, marginParty: "R", totalVotes: 16336 },
      { county: "Wharton", margin: 48, marginParty: "R", totalVotes: 16320 },
      { county: "Jasper", margin: 64, marginParty: "R", totalVotes: 15745 },
      { county: "Caldwell", margin: 9, marginParty: "R", totalVotes: 15540 },
      { county: "Austin", margin: 59, marginParty: "R", totalVotes: 15287 },
      { county: "Maverick", margin: 3, marginParty: "R", totalVotes: 14731 },
      { county: "Val Verde", margin: 16, marginParty: "R", totalVotes: 14283 },
      { county: "Starr", margin: 2, marginParty: "R", totalVotes: 14182 },
      { county: "Cass", margin: 64, marginParty: "R", totalVotes: 14117 },
      { county: "Grimes", margin: 57, marginParty: "R", totalVotes: 13991 },
      { county: "Llano", margin: 59, marginParty: "R", totalVotes: 13622 },
      { county: "Bandera", margin: 57, marginParty: "R", totalVotes: 13526 },
      { county: "Fayette", margin: 58, marginParty: "R", totalVotes: 13282 },
      { county: "Palo Pinto", margin: 62, marginParty: "R", totalVotes: 13241 },
      { county: "Matagorda", margin: 45, marginParty: "R", totalVotes: 13209 },
      { county: "Jim Wells", margin: 7, marginParty: "R", totalVotes: 12960 },
      { county: "Aransas", margin: 50, marginParty: "R", totalVotes: 12954 },
      { county: "San Jacinto", margin: 61, marginParty: "R", totalVotes: 12710 },
      { county: "Panola", margin: 65, marginParty: "R", totalVotes: 11359 },
      { county: "Lampasas", margin: 56, marginParty: "R", totalVotes: 11183 },
      { county: "Milam", margin: 53, marginParty: "R", totalVotes: 11036 },
      { county: "Montague", margin: 74, marginParty: "R", totalVotes: 11013 },
      { county: "Lavaca", margin: 72, marginParty: "R", totalVotes: 10418 },
      { county: "Titus", margin: 51, marginParty: "R", totalVotes: 10127 },
      { county: "Colorado", margin: 54, marginParty: "R", totalVotes: 9919 },
      { county: "Kleberg", margin: 4, marginParty: "R", totalVotes: 9886 },
      { county: "Shelby", margin: 63, marginParty: "R", totalVotes: 9875 },
      { county: "Uvalde", margin: 25, marginParty: "R", totalVotes: 9601 },
      { county: "Bosque", margin: 62, marginParty: "R", totalVotes: 9541 },
      { county: "Howard", margin: 58, marginParty: "R", totalVotes: 9511 },
      { county: "Tyler", margin: 70, marginParty: "R", totalVotes: 9507 },
      { county: "Burleson", margin: 59, marginParty: "R", totalVotes: 9319 },
      { county: "Houston", margin: 53, marginParty: "R", totalVotes: 9285 },
      { county: "Hale", margin: 54, marginParty: "R", totalVotes: 9192 },
      { county: "Limestone", margin: 53, marginParty: "R", totalVotes: 9009 },
      { county: "Leon", margin: 73, marginParty: "R", totalVotes: 9008 },
      { county: "Freestone", margin: 62, marginParty: "R", totalVotes: 8957 },
      { county: "Bee", margin: 32, marginParty: "R", totalVotes: 8672 },
      { county: "Blanco", margin: 49, marginParty: "R", totalVotes: 8494 },
      { county: "Lee", margin: 57, marginParty: "R", totalVotes: 8360 },
      { county: "Eastland", margin: 74, marginParty: "R", totalVotes: 8303 },
      { county: "Young", margin: 73, marginParty: "R", totalVotes: 8268 },
      { county: "Hutchinson", margin: 75, marginParty: "R", totalVotes: 8153 },
      { county: "Robertson", margin: 49, marginParty: "R", totalVotes: 8124 },
      { county: "Hockley", margin: 64, marginParty: "R", totalVotes: 7955 },
      { county: "Calhoun", margin: 46, marginParty: "R", totalVotes: 7758 },
      { county: "DeWitt", margin: 63, marginParty: "R", totalVotes: 7750 },
      { county: "Gonzales", margin: 49, marginParty: "R", totalVotes: 7634 },
      { county: "Gray", margin: 75, marginParty: "R", totalVotes: 7520 },
      { county: "Trinity", margin: 63, marginParty: "R", totalVotes: 7336 },
      { county: "Callahan", margin: 73, marginParty: "R", totalVotes: 6976 },
      { county: "Jones", margin: 68, marginParty: "R", totalVotes: 6901 },
      { county: "Rains", margin: 69, marginParty: "R", totalVotes: 6526 },
      { county: "Comanche", margin: 69, marginParty: "R", totalVotes: 6506 },
      { county: "Gaines", margin: 81, marginParty: "R", totalVotes: 6364 },
      { county: "Jackson", margin: 67, marginParty: "R", totalVotes: 6300 },
      { county: "Falls", margin: 41, marginParty: "R", totalVotes: 6266 },
      { county: "Andrews", margin: 69, marginParty: "R", totalVotes: 5972 },
      { county: "Clay", margin: 76, marginParty: "R", totalVotes: 5879 },
      { county: "Red River", margin: 58, marginParty: "R", totalVotes: 5737 },
      { county: "Newton", margin: 65, marginParty: "R", totalVotes: 5690 },
      { county: "Scurry", margin: 69, marginParty: "R", totalVotes: 5631 },
      { county: "Sabine", margin: 77, marginParty: "R", totalVotes: 5540 },
      { county: "Madison", margin: 61, marginParty: "R", totalVotes: 5443 },
      { county: "Willacy", margin: 10, marginParty: "D", totalVotes: 5415 },
      { county: "Morris", margin: 48, marginParty: "R", totalVotes: 5390 },
      { county: "Franklin", margin: 66, marginParty: "R", totalVotes: 5276 },
      { county: "Somervell", margin: 65, marginParty: "R", totalVotes: 5271 },
      { county: "Moore", margin: 62, marginParty: "R", totalVotes: 5248 },
      { county: "Camp", margin: 50, marginParty: "R", totalVotes: 5226 },
      { county: "Archer", margin: 77, marginParty: "R", totalVotes: 5109 },
      { county: "Live Oak", margin: 66, marginParty: "R", totalVotes: 5062 },
      { county: "Nolan", margin: 53, marginParty: "R", totalVotes: 5039 },
      { county: "Karnes", margin: 51, marginParty: "R", totalVotes: 5010 },
      { county: "Frio", margin: 11, marginParty: "R", totalVotes: 4810 },
      { county: "Marion", margin: 51, marginParty: "R", totalVotes: 4693 },
      { county: "Brewster", margin: 9, marginParty: "R", totalVotes: 4544 },
      { county: "Hamilton", margin: 68, marginParty: "R", totalVotes: 4469 },
      { county: "Wilbarger", margin: 56, marginParty: "R", totalVotes: 4431 },
      { county: "Zapata", margin: 6, marginParty: "R", totalVotes: 4265 },
      { county: "Deaf Smith", margin: 49, marginParty: "R", totalVotes: 4225 },
      { county: "Jack", margin: 78, marginParty: "R", totalVotes: 4181 },
      { county: "Duval", margin: 8, marginParty: "D", totalVotes: 4177 },
      { county: "Pecos", margin: 39, marginParty: "R", totalVotes: 4142 },
      { county: "Coleman", margin: 76, marginParty: "R", totalVotes: 4122 },
      { county: "Lamb", margin: 62, marginParty: "R", totalVotes: 4111 },
      { county: "Runnels", margin: 72, marginParty: "R", totalVotes: 4027 },
      { county: "Goliad", margin: 55, marginParty: "R", totalVotes: 3936 },
      { county: "Stephens", margin: 74, marginParty: "R", totalVotes: 3727 },
      { county: "Ward", margin: 60, marginParty: "R", totalVotes: 3727 },
      { county: "San Augustine", margin: 55, marginParty: "R", totalVotes: 3707 },
      { county: "McCulloch", margin: 70, marginParty: "R", totalVotes: 3498 },
      { county: "Dawson", margin: 58, marginParty: "R", totalVotes: 3455 },
      { county: "Terry", margin: 61, marginParty: "R", totalVotes: 3347 },
      { county: "Reeves", margin: 27, marginParty: "R", totalVotes: 3288 },
      { county: "Zavala", margin: 25, marginParty: "D", totalVotes: 3269 },
      { county: "Dimmit", margin: 17, marginParty: "D", totalVotes: 3243 },
      { county: "Carson", margin: 77, marginParty: "R", totalVotes: 3147 },
      { county: "Refugio", margin: 35, marginParty: "R", totalVotes: 3029 },
      { county: "Ochiltree", margin: 80, marginParty: "R", totalVotes: 2996 },
      { county: "Mills", margin: 73, marginParty: "R", totalVotes: 2730 },
      { county: "San Saba", margin: 74, marginParty: "R", totalVotes: 2689 },
      { county: "Delta", margin: 64, marginParty: "R", totalVotes: 2655 },
      { county: "Lynn", margin: 69, marginParty: "R", totalVotes: 2528 },
      { county: "Mason", margin: 63, marginParty: "R", totalVotes: 2507 },
      { county: "Parmer", margin: 68, marginParty: "R", totalVotes: 2474 },
      { county: "Mitchell", margin: 68, marginParty: "R", totalVotes: 2473 },
      { county: "Kimble", margin: 73, marginParty: "R", totalVotes: 2379 },
      { county: "Yoakum", margin: 67, marginParty: "R", totalVotes: 2341 },
      { county: "Brooks", margin: 22, marginParty: "D", totalVotes: 2301 },
      { county: "Wheeler", margin: 81, marginParty: "R", totalVotes: 2253 },
      { county: "Childress", margin: 73, marginParty: "R", totalVotes: 2244 },
      { county: "Swisher", margin: 58, marginParty: "R", totalVotes: 2233 },
      { county: "Haskell", margin: 66, marginParty: "R", totalVotes: 2228 },
      { county: "La Salle", margin: 6, marginParty: "R", totalVotes: 2111 },
      { county: "Martin", margin: 72, marginParty: "R", totalVotes: 2067 },
      { county: "Floyd", margin: 59, marginParty: "R", totalVotes: 2065 },
      { county: "Hartley", margin: 82, marginParty: "R", totalVotes: 2005 },
      { county: "Castro", margin: 57, marginParty: "R", totalVotes: 1983 },
      { county: "Hansford", margin: 84, marginParty: "R", totalVotes: 1979 },
      { county: "Real", margin: 64, marginParty: "R", totalVotes: 1949 },
      { county: "Presidio", margin: 31, marginParty: "D", totalVotes: 1940 },
      { county: "Winkler", margin: 66, marginParty: "R", totalVotes: 1891 },
      { county: "Crosby", margin: 50, marginParty: "R", totalVotes: 1860 },
      { county: "Fisher", margin: 59, marginParty: "R", totalVotes: 1811 },
      { county: "Coke", margin: 75, marginParty: "R", totalVotes: 1804 },
      { county: "Bailey", margin: 60, marginParty: "R", totalVotes: 1713 },
      { county: "Shackelford", margin: 79, marginParty: "R", totalVotes: 1710 },
      { county: "Donley", margin: 76, marginParty: "R", totalVotes: 1670 },
      { county: "Baylor", margin: 74, marginParty: "R", totalVotes: 1668 },
      { county: "Hemphill", margin: 74, marginParty: "R", totalVotes: 1599 },
      { county: "Garza", margin: 70, marginParty: "R", totalVotes: 1568 },
      { county: "Jim Hogg", margin: 22, marginParty: "D", totalVotes: 1518 },
      { county: "Dallam", margin: 75, marginParty: "R", totalVotes: 1425 },
      { county: "Hardeman", margin: 68, marginParty: "R", totalVotes: 1398 },
      { county: "Kinney", margin: 42, marginParty: "R", totalVotes: 1387 },
      { county: "Sutton", margin: 64, marginParty: "R", totalVotes: 1387 },
      { county: "Crockett", margin: 50, marginParty: "R", totalVotes: 1372 },
      { county: "Knox", margin: 62, marginParty: "R", totalVotes: 1364 },
      { county: "Crane", margin: 69, marginParty: "R", totalVotes: 1335 },
      { county: "Upton", margin: 72, marginParty: "R", totalVotes: 1264 },
      { county: "Lipscomb", margin: 77, marginParty: "R", totalVotes: 1246 },
      { county: "Concho", margin: 69, marginParty: "R", totalVotes: 1184 },
      { county: "Collingsworth", margin: 76, marginParty: "R", totalVotes: 1181 },
      { county: "Jeff Davis", margin: 19, marginParty: "R", totalVotes: 1155 },
      { county: "Hall", margin: 71, marginParty: "R", totalVotes: 1131 },
      { county: "Armstrong", margin: 81, marginParty: "R", totalVotes: 1112 },
      { county: "Schleicher", margin: 61, marginParty: "R", totalVotes: 1098 },
      { county: "Menard", margin: 61, marginParty: "R", totalVotes: 1036 },
      { county: "Hudspeth", margin: 41, marginParty: "R", totalVotes: 1020 },
      { county: "Dickens", margin: 68, marginParty: "R", totalVotes: 981 },
      { county: "Edwards", margin: 67, marginParty: "R", totalVotes: 974 },
      { county: "Oldham", margin: 80, marginParty: "R", totalVotes: 961 },
      { county: "Reagan", margin: 65, marginParty: "R", totalVotes: 936 },
      { county: "Throckmorton", margin: 81, marginParty: "R", totalVotes: 889 },
      { county: "Sherman", margin: 80, marginParty: "R", totalVotes: 887 },
      { county: "Cochran", margin: 63, marginParty: "R", totalVotes: 879 },
      { county: "Irion", margin: 71, marginParty: "R", totalVotes: 867 },
      { county: "Culberson", margin: 7, marginParty: "R", totalVotes: 745 },
      { county: "Briscoe", margin: 77, marginParty: "R", totalVotes: 743 },
      { county: "Stonewall", margin: 65, marginParty: "R", totalVotes: 712 },
      { county: "Glasscock", margin: 88, marginParty: "R", totalVotes: 660 },
      { county: "Cottle", margin: 71, marginParty: "R", totalVotes: 643 },
      { county: "Motley", margin: 86, marginParty: "R", totalVotes: 642 },
      { county: "Sterling", margin: 80, marginParty: "R", totalVotes: 624 },
      { county: "Roberts", margin: 92, marginParty: "R", totalVotes: 567 },
      { county: "Foard", margin: 64, marginParty: "R", totalVotes: 538 },
      { county: "McMullen", margin: 79, marginParty: "R", totalVotes: 476 },
      { county: "Kent", margin: 73, marginParty: "R", totalVotes: 448 },
      { county: "Terrell", margin: 52, marginParty: "R", totalVotes: 400 },
      { county: "Borden", margin: 92, marginParty: "R", totalVotes: 383 },
      { county: "Kenedy", margin: 31, marginParty: "R", totalVotes: 144 },
      { county: "King", margin: 93, marginParty: "R", totalVotes: 134 },
      { county: "Loving", margin: 61, marginParty: "R", totalVotes: 95 }
    ]
  },

  // Michigan
  {
    state: "MI",
    demCandidate: "Elissa Slotkin",
    repCandidate: "Mike Rogers",
    indCandidate: null,
    demVotes: 2712686,
    repVotes: 2693680,
    indVotes: 0,
    otherVotes: 56697,
    totalVotes: 5577183,
    winner: "D",
    incumbent: null,
    counties: [
      { county: "Wayne", margin: 32, marginParty: "D", totalVotes: 838858 },
      { county: "Oakland", margin: 12, marginParty: "D", totalVotes: 763454 },
      { county: "Macomb", margin: 10, marginParty: "R", totalVotes: 498724 },
      { county: "Kent", margin: 5, marginParty: "D", totalVotes: 368158 },
      { county: "Genesee", margin: 8, marginParty: "D", totalVotes: 219459 },
      { county: "Washtenaw", margin: 44, marginParty: "D", totalVotes: 219068 },
      { county: "Ottawa", margin: 22, marginParty: "R", totalVotes: 177092 },
      { county: "Ingham", margin: 32, marginParty: "D", totalVotes: 146816 },
      { county: "Kalamazoo", margin: 17, marginParty: "D", totalVotes: 143933 },
      { county: "Livingston", margin: 21, marginParty: "R", totalVotes: 131252 },
      { county: "Saginaw", margin: 0.01, marginParty: "D", totalVotes: 101936 },
      { county: "St. Clair", margin: 30, marginParty: "R", totalVotes: 94432 },
      { county: "Muskegon", margin: 0.05, marginParty: "R", totalVotes: 93438 },
      { county: "Monroe", margin: 24, marginParty: "R", totalVotes: 88962 },
      { county: "Berrien", margin: 11, marginParty: "R", totalVotes: 83160 },
      { county: "Jackson", margin: 19, marginParty: "R", totalVotes: 82405 },
      { county: "Allegan", margin: 27, marginParty: "R", totalVotes: 71370 },
      { county: "Calhoun", margin: 12, marginParty: "R", totalVotes: 67202 },
      { county: "Eaton", margin: 0.27, marginParty: "R", totalVotes: 64629 },
      { county: "Grand Traverse", margin: 2, marginParty: "R", totalVotes: 62022 },
      { county: "Bay", margin: 10, marginParty: "R", totalVotes: 60151 },
      { county: "Lapeer", margin: 36, marginParty: "R", totalVotes: 54655 },
      { county: "Lenawee", margin: 23, marginParty: "R", totalVotes: 53784 },
      { county: "Midland", margin: 14, marginParty: "R", totalVotes: 49601 },
      { county: "Clinton", margin: 7, marginParty: "R", totalVotes: 49545 },
      { county: "Van Buren", margin: 14, marginParty: "R", totalVotes: 40596 },
      { county: "Shiawassee", margin: 20, marginParty: "R", totalVotes: 40103 },
      { county: "Marquette", margin: 9, marginParty: "D", totalVotes: 38389 },
      { county: "Barry", margin: 32, marginParty: "R", totalVotes: 38132 },
      { county: "Montcalm", margin: 37, marginParty: "R", totalVotes: 34328 },
      { county: "Ionia", margin: 30, marginParty: "R", totalVotes: 33553 },
      { county: "Isabella", margin: 6, marginParty: "R", totalVotes: 30256 },
      { county: "Tuscola", margin: 39, marginParty: "R", totalVotes: 30140 },
      { county: "Newaygo", margin: 41, marginParty: "R", totalVotes: 28837 },
      { county: "St. Joseph", margin: 33, marginParty: "R", totalVotes: 28762 },
      { county: "Cass", margin: 35, marginParty: "R", totalVotes: 27415 },
      { county: "Hillsdale", margin: 49, marginParty: "R", totalVotes: 24405 },
      { county: "Sanilac", margin: 45, marginParty: "R", totalVotes: 23007 },
      { county: "Emmet", margin: 11, marginParty: "R", totalVotes: 22668 },
      { county: "Mecosta", margin: 29, marginParty: "R", totalVotes: 22159 },
      { county: "Delta", margin: 29, marginParty: "R", totalVotes: 21478 },
      { county: "Branch", margin: 40, marginParty: "R", totalVotes: 20792 },
      { county: "Gratiot", margin: 29, marginParty: "R", totalVotes: 19510 },
      { county: "Wexford", margin: 33, marginParty: "R", totalVotes: 19214 },
      { county: "Houghton", margin: 17, marginParty: "R", totalVotes: 19126 },
      { county: "Huron", margin: 38, marginParty: "R", totalVotes: 18550 },
      { county: "Chippewa", margin: 23, marginParty: "R", totalVotes: 18013 },
      { county: "Mason", margin: 22, marginParty: "R", totalVotes: 17857 },
      { county: "Leelanau", margin: 6, marginParty: "D", totalVotes: 17555 },
      { county: "Charlevoix", margin: 17, marginParty: "R", totalVotes: 17384 },
      { county: "Clare", margin: 34, marginParty: "R", totalVotes: 16993 },
      { county: "Alpena", margin: 28, marginParty: "R", totalVotes: 16877 },
      { county: "Antrim", margin: 24, marginParty: "R", totalVotes: 16732 },
      { county: "Cheboygan", margin: 30, marginParty: "R", totalVotes: 16164 },
      { county: "Roscommon", margin: 31, marginParty: "R", totalVotes: 15841 },
      { county: "Otsego", margin: 34, marginParty: "R", totalVotes: 15739 },
      { county: "Iosco", margin: 27, marginParty: "R", totalVotes: 15423 },
      { county: "Gladwin", margin: 38, marginParty: "R", totalVotes: 15193 },
      { county: "Manistee", margin: 15, marginParty: "R", totalVotes: 15125 },
      { county: "Dickinson", margin: 36, marginParty: "R", totalVotes: 15102 },
      { county: "Oceana", margin: 28, marginParty: "R", totalVotes: 14652 },
      { county: "Osceola", margin: 46, marginParty: "R", totalVotes: 13008 },
      { county: "Benzie", margin: 9, marginParty: "R", totalVotes: 12739 },
      { county: "Menominee", margin: 34, marginParty: "R", totalVotes: 12703 },
      { county: "Ogemaw", margin: 38, marginParty: "R", totalVotes: 12311 },
      { county: "Kalkaska", margin: 41, marginParty: "R", totalVotes: 11315 },
      { county: "Missaukee", margin: 54, marginParty: "R", totalVotes: 9018 },
      { county: "Arenac", margin: 35, marginParty: "R", totalVotes: 8938 },
      { county: "Presque Isle", margin: 28, marginParty: "R", totalVotes: 8606 },
      { county: "Crawford", margin: 32, marginParty: "R", totalVotes: 8331 },
      { county: "Gogebic", margin: 16, marginParty: "R", totalVotes: 8050 },
      { county: "Alcona", margin: 40, marginParty: "R", totalVotes: 7367 },
      { county: "Mackinac", margin: 24, marginParty: "R", totalVotes: 7104 },
      { county: "Iron", margin: 28, marginParty: "R", totalVotes: 6904 },
      { county: "Lake", margin: 30, marginParty: "R", totalVotes: 6767 },
      { county: "Montmorency", margin: 45, marginParty: "R", totalVotes: 6271 },
      { county: "Alger", margin: 19, marginParty: "R", totalVotes: 5158 },
      { county: "Oscoda", margin: 42, marginParty: "R", totalVotes: 5072 },
      { county: "Schoolcraft", margin: 29, marginParty: "R", totalVotes: 4794 },
      { county: "Baraga", margin: 29, marginParty: "R", totalVotes: 4246 },
      { county: "Ontonagon", margin: 29, marginParty: "R", totalVotes: 3774 },
      { county: "Luce", margin: 45, marginParty: "R", totalVotes: 2946 },
      { county: "Keweenaw", margin: 14, marginParty: "R", totalVotes: 1585 }
    ]
  },

  // Wisconsin
  {
    state: "WI",
    demCandidate: "Tammy Baldwin",
    repCandidate: "Eric Hovde",
    indCandidate: "Phil Anderson",
    demVotes: 1672777,
    repVotes: 1643996,
    indVotes: 42315,
    otherVotes: 28751,
    totalVotes: 3387839,
    winner: "D",
    incumbent: "D",
    counties: [
      { county: "Milwaukee", margin: 40, marginParty: "D", totalVotes: 456689 },
      { county: "Dane", margin: 52, marginParty: "D", totalVotes: 363052 },
      { county: "Waukesha", margin: 21, marginParty: "R", totalVotes: 273439 },
      { county: "Brown", margin: 6, marginParty: "R", totalVotes: 147751 },
      { county: "Outagamie", margin: 9, marginParty: "R", totalVotes: 111099 },
      { county: "Racine", margin: 5, marginParty: "R", totalVotes: 106498 },
      { county: "Winnebago", margin: 3, marginParty: "R", totalVotes: 94419 },
      { county: "Washington", margin: 37, marginParty: "R", totalVotes: 90661 },
      { county: "Kenosha", margin: 4, marginParty: "R", totalVotes: 89486 },
      { county: "Rock", margin: 10, marginParty: "D", totalVotes: 87373 },
      { county: "Marathon", margin: 16, marginParty: "R", totalVotes: 78254 },
      { county: "La Crosse", margin: 12, marginParty: "D", totalVotes: 71615 },
      { county: "Sheboygan", margin: 15, marginParty: "R", totalVotes: 66847 },
      { county: "Ozaukee", margin: 12, marginParty: "R", totalVotes: 63020 },
      { county: "Eau Claire", margin: 13, marginParty: "D", totalVotes: 62323 },
      { county: "St. Croix", margin: 18, marginParty: "R", totalVotes: 59996 },
      { county: "Walworth", margin: 21, marginParty: "R", totalVotes: 59977 },
      { county: "Fond du Lac", margin: 26, marginParty: "R", totalVotes: 58024 },
      { county: "Dodge", margin: 30, marginParty: "R", totalVotes: 49895 },
      { county: "Jefferson", margin: 15, marginParty: "R", totalVotes: 49645 },
      { county: "Manitowoc", margin: 21, marginParty: "R", totalVotes: 45934 },
      { county: "Portage", margin: 4, marginParty: "D", totalVotes: 42907 },
      { county: "Wood", margin: 16, marginParty: "R", totalVotes: 41804 },
      { county: "Chippewa", margin: 19, marginParty: "R", totalVotes: 38029 },
      { county: "Sauk", margin: 1.4, marginParty: "D", totalVotes: 37177 },
      { county: "Columbia", margin: 1.1, marginParty: "R", totalVotes: 34603 },
      { county: "Calumet", margin: 19, marginParty: "R", totalVotes: 32662 },
      { county: "Waupaca", margin: 30, marginParty: "R", totalVotes: 30084 },
      { county: "Polk", margin: 28, marginParty: "R", totalVotes: 27929 },
      { county: "Grant", margin: 14, marginParty: "R", totalVotes: 26893 },
      { county: "Barron", margin: 27, marginParty: "R", totalVotes: 26520 },
      { county: "Dunn", margin: 13, marginParty: "R", totalVotes: 25376 },
      { county: "Pierce", margin: 15, marginParty: "R", totalVotes: 25128 },
      { county: "Douglas", margin: 8, marginParty: "D", totalVotes: 24868 },
      { county: "Oconto", margin: 40, marginParty: "R", totalVotes: 24690 },
      { county: "Oneida", margin: 15, marginParty: "R", totalVotes: 24653 },
      { county: "Marinette", margin: 33, marginParty: "R", totalVotes: 24078 },
      { county: "Shawano", margin: 32, marginParty: "R", totalVotes: 23286 },
      { county: "Monroe", margin: 23, marginParty: "R", totalVotes: 23145 },
      { county: "Green", margin: 4, marginParty: "D", totalVotes: 21924 },
      { county: "Door", margin: 3, marginParty: "D", totalVotes: 20796 },
      { county: "Lincoln", margin: 21, marginParty: "R", totalVotes: 17086 },
      { county: "Vernon", margin: 3, marginParty: "R", totalVotes: 16474 },
      { county: "Vilas", margin: 22, marginParty: "R", totalVotes: 16004 },
      { county: "Trempealeau", margin: 17, marginParty: "R", totalVotes: 15910 },
      { county: "Clark", margin: 34, marginParty: "R", totalVotes: 15162 },
      { county: "Iowa", margin: 11, marginParty: "D", totalVotes: 14559 },
      { county: "Juneau", margin: 28, marginParty: "R", totalVotes: 14421 },
      { county: "Waushara", margin: 32, marginParty: "R", totalVotes: 14250 },
      { county: "Adams", margin: 22, marginParty: "R", totalVotes: 12748 },
      { county: "Kewaunee", margin: 29, marginParty: "R", totalVotes: 12371 },
      { county: "Langlade", margin: 31, marginParty: "R", totalVotes: 11555 },
      { county: "Bayfield", margin: 14, marginParty: "D", totalVotes: 11159 },
      { county: "Taylor", margin: 44, marginParty: "R", totalVotes: 11122 },
      { county: "Sawyer", margin: 14, marginParty: "R", totalVotes: 11029 },
      { county: "Green Lake", margin: 32, marginParty: "R", totalVotes: 10980 },
      { county: "Washburn", margin: 26, marginParty: "R", totalVotes: 10878 },
      { county: "Burnett", margin: 28, marginParty: "R", totalVotes: 10731 },
      { county: "Jackson", margin: 14, marginParty: "R", totalVotes: 10397 },
      { county: "Marquette", margin: 25, marginParty: "R", totalVotes: 9366 },
      { county: "Richland", margin: 9, marginParty: "R", totalVotes: 9225 },
      { county: "Crawford", margin: 8, marginParty: "R", totalVotes: 9040 },
      { county: "Ashland", margin: 11, marginParty: "D", totalVotes: 8833 },
      { county: "Price", margin: 25, marginParty: "R", totalVotes: 8805 },
      { county: "Lafayette", margin: 12, marginParty: "R", totalVotes: 8768 },
      { county: "Rusk", margin: 34, marginParty: "R", totalVotes: 8196 },
      { county: "Buffalo", margin: 25, marginParty: "R", totalVotes: 8012 },
      { county: "Forest", margin: 26, marginParty: "R", totalVotes: 5189 },
      { county: "Pepin", margin: 24, marginParty: "R", totalVotes: 4318 },
      { county: "Iron", margin: 23, marginParty: "R", totalVotes: 4034 },
      { county: "Florence", margin: 47, marginParty: "R", totalVotes: 3134 },
      { county: "Menominee", margin: 60, marginParty: "D", totalVotes: 1534 }
    ]
  },

  // Ohio
  {
    state: "OH",
    demCandidate: "Sherrod Brown",
    repCandidate: "Bernie Moreno",
    indCandidate: null,
    demVotes: 2650949,
    repVotes: 2857383,
    indVotes: 0,
    otherVotes: 195648,
    totalVotes: 5703980,
    winner: "R",
    incumbent: "D",
    counties: [
      { county: "Franklin", margin: 34, marginParty: "D", totalVotes: 588929 },
      { county: "Cuyahoga", margin: 38, marginParty: "D", totalVotes: 568952 },
      { county: "Hamilton", margin: 19, marginParty: "D", totalVotes: 407678 },
      { county: "Summit", margin: 14, marginParty: "D", totalVotes: 271235 },
      { county: "Montgomery", margin: 7, marginParty: "D", totalVotes: 251908 },
      { county: "Lucas", margin: 19, marginParty: "D", totalVotes: 189009 },
      { county: "Stark", margin: 13, marginParty: "R", totalVotes: 181730 },
      { county: "Butler", margin: 19, marginParty: "R", totalVotes: 181232 },
      { county: "Lorain", margin: 5, marginParty: "D", totalVotes: 156164 },
      { county: "Warren", margin: 26, marginParty: "R", totalVotes: 138865 },
      { county: "Delaware", margin: 1.5, marginParty: "R", totalVotes: 132974 },
      { county: "Lake", margin: 5, marginParty: "R", totalVotes: 126250 },
      { county: "Clermont", margin: 29, marginParty: "R", totalVotes: 113061 },
      { county: "Mahoning", margin: 0.2, marginParty: "R", totalVotes: 111491 },
      { county: "Medina", margin: 15, marginParty: "R", totalVotes: 105340 },
      { county: "Trumbull", margin: 6, marginParty: "R", totalVotes: 95649 },
      { county: "Licking", margin: 21, marginParty: "R", totalVotes: 94297 },
      { county: "Greene", margin: 14, marginParty: "R", totalVotes: 89856 },
      { county: "Fairfield", margin: 16, marginParty: "R", totalVotes: 83851 },
      { county: "Portage", margin: 6, marginParty: "R", totalVotes: 82236 },
      { county: "Wood", margin: 2, marginParty: "R", totalVotes: 66795 },
      { county: "Clark", margin: 21, marginParty: "R", totalVotes: 62628 },
      { county: "Miami", margin: 37, marginParty: "R", totalVotes: 58786 },
      { county: "Richland", margin: 33, marginParty: "R", totalVotes: 57743 },
      { county: "Geauga", margin: 16, marginParty: "R", totalVotes: 54630 },
      { county: "Wayne", margin: 31, marginParty: "R", totalVotes: 52743 },
      { county: "Columbiana", margin: 38, marginParty: "R", totalVotes: 47594 },
      { county: "Allen", margin: 35, marginParty: "R", totalVotes: 45983 },
      { county: "Ashtabula", margin: 17, marginParty: "R", totalVotes: 42682 },
      { county: "Tuscarawas", margin: 33, marginParty: "R", totalVotes: 42635 },
      { county: "Erie", margin: 4, marginParty: "R", totalVotes: 39307 },
      { county: "Muskingum", margin: 35, marginParty: "R", totalVotes: 38937 },
      { county: "Hancock", margin: 31, marginParty: "R", totalVotes: 37520 },
      { county: "Union", margin: 22, marginParty: "R", totalVotes: 36956 },
      { county: "Ross", margin: 28, marginParty: "R", totalVotes: 32687 },
      { county: "Knox", margin: 37, marginParty: "R", totalVotes: 31960 },
      { county: "Jefferson", margin: 32, marginParty: "R", totalVotes: 30808 },
      { county: "Belmont", margin: 35, marginParty: "R", totalVotes: 30747 },
      { county: "Scioto", margin: 38, marginParty: "R", totalVotes: 30519 },
      { county: "Washington", margin: 35, marginParty: "R", totalVotes: 30201 },
      { county: "Sandusky", margin: 21, marginParty: "R", totalVotes: 29255 },
      { county: "Pickaway", margin: 38, marginParty: "R", totalVotes: 29050 },
      { county: "Darke", margin: 57, marginParty: "R", totalVotes: 26859 },
      { county: "Huron", margin: 32, marginParty: "R", totalVotes: 26830 },
      { county: "Marion", margin: 30, marginParty: "R", totalVotes: 26779 },
      { county: "Lawrence", margin: 41, marginParty: "R", totalVotes: 26329 },
      { county: "Ashland", margin: 41, marginParty: "R", totalVotes: 26193 },
      { county: "Athens", margin: 18, marginParty: "D", totalVotes: 25625 },
      { county: "Auglaize", margin: 55, marginParty: "R", totalVotes: 25472 },
      { county: "Seneca", margin: 28, marginParty: "R", totalVotes: 25090 },
      { county: "Shelby", margin: 57, marginParty: "R", totalVotes: 25067 },
      { county: "Ottawa", margin: 16, marginParty: "R", totalVotes: 23697 },
      { county: "Mercer", margin: 60, marginParty: "R", totalVotes: 23467 },
      { county: "Logan", margin: 48, marginParty: "R", totalVotes: 23355 },
      { county: "Fulton", margin: 35, marginParty: "R", totalVotes: 22080 },
      { county: "Preble", margin: 50, marginParty: "R", totalVotes: 21527 },
      { county: "Brown", margin: 52, marginParty: "R", totalVotes: 20978 },
      { county: "Clinton", margin: 46, marginParty: "R", totalVotes: 20553 },
      { county: "Madison", margin: 34, marginParty: "R", totalVotes: 20458 },
      { county: "Champaign", margin: 41, marginParty: "R", totalVotes: 20260 },
      { county: "Crawford", margin: 42, marginParty: "R", totalVotes: 20128 },
      { county: "Highland", margin: 54, marginParty: "R", totalVotes: 19728 },
      { county: "Putnam", margin: 61, marginParty: "R", totalVotes: 19704 },
      { county: "Defiance", margin: 33, marginParty: "R", totalVotes: 18730 },
      { county: "Morrow", margin: 46, marginParty: "R", totalVotes: 18534 },
      { county: "Williams", margin: 39, marginParty: "R", totalVotes: 18016 },
      { county: "Guernsey", margin: 40, marginParty: "R", totalVotes: 17386 },
      { county: "Perry", margin: 43, marginParty: "R", totalVotes: 16772 },
      { county: "Coshocton", margin: 40, marginParty: "R", totalVotes: 16184 },
      { county: "Van Wert", margin: 52, marginParty: "R", totalVotes: 14605 },
      { county: "Henry", margin: 36, marginParty: "R", totalVotes: 14603 },
      { county: "Jackson", margin: 49, marginParty: "R", totalVotes: 14117 },
      { county: "Carroll", margin: 44, marginParty: "R", totalVotes: 13659 },
      { county: "Hocking", margin: 34, marginParty: "R", totalVotes: 13296 },
      { county: "Hardin", margin: 43, marginParty: "R", totalVotes: 12791 },
      { county: "Gallia", margin: 50, marginParty: "R", totalVotes: 12719 },
      { county: "Fayette", margin: 44, marginParty: "R", totalVotes: 12393 },
      { county: "Holmes", margin: 62, marginParty: "R", totalVotes: 12196 },
      { county: "Adams", margin: 57, marginParty: "R", totalVotes: 12172 },
      { county: "Pike", margin: 41, marginParty: "R", totalVotes: 12043 },
      { county: "Wyandot", margin: 43, marginParty: "R", totalVotes: 11276 },
      { county: "Meigs", margin: 48, marginParty: "R", totalVotes: 10215 },
      { county: "Paulding", margin: 50, marginParty: "R", totalVotes: 9190 },
      { county: "Harrison", margin: 43, marginParty: "R", totalVotes: 7068 },
      { county: "Monroe", margin: 45, marginParty: "R", totalVotes: 6651 },
      { county: "Morgan", margin: 42, marginParty: "R", totalVotes: 6641 },
      { county: "Noble", margin: 53, marginParty: "R", totalVotes: 6073 },
      { county: "Vinton", margin: 47, marginParty: "R", totalVotes: 5598 }
    ]
  },

  // Montana
  {
    state: "MT",
    demCandidate: "Jon Tester",
    repCandidate: "Tim Sheehy",
    indCandidate: null,
    demVotes: 276305,
    repVotes: 319682,
    indVotes: 0,
    otherVotes: 11275,
    totalVotes: 607262,
    winner: "R",
    incumbent: "D",
    counties: [
      { county: "Yellowstone", margin: 16, marginParty: "R", totalVotes: 81985 },
      { county: "Missoula", margin: 34, marginParty: "D", totalVotes: 73372 },
      { county: "Gallatin", margin: 12, marginParty: "D", totalVotes: 70555 },
      { county: "Flathead", margin: 24, marginParty: "R", totalVotes: 63542 },
      { county: "Lewis and Clark", margin: 7, marginParty: "D", totalVotes: 42389 },
      { county: "Cascade", margin: 7, marginParty: "R", totalVotes: 37877 },
      { county: "Ravalli", margin: 29, marginParty: "R", totalVotes: 30047 },
      { county: "Silver Bow", margin: 31, marginParty: "D", totalVotes: 18418 },
      { county: "Lake", margin: 6, marginParty: "R", totalVotes: 16993 },
      { county: "Lincoln", margin: 42, marginParty: "R", totalVotes: 11819 },
      { county: "Park", margin: 3, marginParty: "D", totalVotes: 11816 },
      { county: "Jefferson", margin: 24, marginParty: "R", totalVotes: 8353 },
      { county: "Sanders", margin: 42, marginParty: "R", totalVotes: 8106 },
      { county: "Carbon", margin: 23, marginParty: "R", totalVotes: 7388 },
      { county: "Hill", margin: 3, marginParty: "D", totalVotes: 6832 },
      { county: "Fergus", margin: 42, marginParty: "R", totalVotes: 6763 },
      { county: "Madison", margin: 36, marginParty: "R", totalVotes: 6514 },
      { county: "Stillwater", margin: 53, marginParty: "R", totalVotes: 5932 },
      { county: "Beaverhead", margin: 29, marginParty: "R", totalVotes: 5841 },
      { county: "Custer", margin: 34, marginParty: "R", totalVotes: 5820 },
      { county: "Richland", margin: 50, marginParty: "R", totalVotes: 5300 },
      { county: "Glacier", margin: 43, marginParty: "D", totalVotes: 5134 },
      { county: "Deer Lodge", margin: 24, marginParty: "D", totalVotes: 4910 },
      { county: "Broadwater", margin: 47, marginParty: "R", totalVotes: 4842 },
      { county: "Dawson", margin: 43, marginParty: "R", totalVotes: 4653 },
      { county: "Big Horn", margin: 28, marginParty: "D", totalVotes: 4453 },
      { county: "Valley", margin: 33, marginParty: "R", totalVotes: 4093 },
      { county: "Roosevelt", margin: 15, marginParty: "D", totalVotes: 3958 },
      { county: "Rosebud", margin: 21, marginParty: "R", totalVotes: 3724 },
      { county: "Teton", margin: 31, marginParty: "R", totalVotes: 3606 },
      { county: "Powell", margin: 33, marginParty: "R", totalVotes: 3301 },
      { county: "Blaine", margin: 20, marginParty: "D", totalVotes: 3057 },
      { county: "Musselshell", margin: 62, marginParty: "R", totalVotes: 3005 },
      { county: "Chouteau", margin: 12, marginParty: "R", totalVotes: 2961 },
      { county: "Pondera", margin: 27, marginParty: "R", totalVotes: 2866 },
      { county: "Mineral", margin: 31, marginParty: "R", totalVotes: 2849 },
      { county: "Sweet Grass", margin: 42, marginParty: "R", totalVotes: 2402 },
      { county: "Phillips", margin: 54, marginParty: "R", totalVotes: 2200 },
      { county: "Granite", margin: 27, marginParty: "R", totalVotes: 2185 },
      { county: "Toole", margin: 43, marginParty: "R", totalVotes: 2044 },
      { county: "Sheridan", margin: 25, marginParty: "R", totalVotes: 1897 },
      { county: "Fallon", margin: 63, marginParty: "R", totalVotes: 1495 },
      { county: "Judith Basin", margin: 47, marginParty: "R", totalVotes: 1360 },
      { county: "Meagher", margin: 45, marginParty: "R", totalVotes: 1180 },
      { county: "Powder River", margin: 61, marginParty: "R", totalVotes: 1110 },
      { county: "Wheatland", margin: 47, marginParty: "R", totalVotes: 1086 },
      { county: "McCone", margin: 66, marginParty: "R", totalVotes: 1085 },
      { county: "Liberty", margin: 38, marginParty: "R", totalVotes: 1002 },
      { county: "Daniels", margin: 52, marginParty: "R", totalVotes: 954 },
      { county: "Carter", margin: 73, marginParty: "R", totalVotes: 854 },
      { county: "Garfield", margin: 82, marginParty: "R", totalVotes: 796 },
      { county: "Prairie", margin: 45, marginParty: "R", totalVotes: 693 },
      { county: "Wibaux", margin: 53, marginParty: "R", totalVotes: 550 },
      { county: "Golden Valley", margin: 64, marginParty: "R", totalVotes: 520 },
      { county: "Treasure", margin: 53, marginParty: "R", totalVotes: 447 },
      { county: "Petroleum", margin: 68, marginParty: "R", totalVotes: 328 }
    ]
  },

  // Nebraska
  {
    state: "NE",
    demCandidate: null,
    repCandidate: "Deb Fischer",
    indCandidate: "Dan Osborn",
    demVotes: 0,
    repVotes: 499124,
    indVotes: 436493,
    otherVotes: 0,
    totalVotes: 935617,
    winner: "R",
    incumbent: "R",
    counties: [
      { county: "Douglas", margin: 17, marginParty: "I", totalVotes: 268528 },
      { county: "Lancaster", margin: 17, marginParty: "I", totalVotes: 156651 },
      { county: "Sarpy", margin: 0.37, marginParty: "I", totalVotes: 99265 },
      { county: "Buffalo", margin: 29, marginParty: "R", totalVotes: 23570 },
      { county: "Hall", margin: 18, marginParty: "R", totalVotes: 22560 },
      { county: "Lincoln", margin: 31, marginParty: "R", totalVotes: 16304 },
      { county: "Dodge", margin: 12, marginParty: "R", totalVotes: 16245 },
      { county: "Platte", margin: 41, marginParty: "R", totalVotes: 15595 },
      { county: "Madison", margin: 36, marginParty: "R", totalVotes: 15520 },
      { county: "Cass", margin: 17, marginParty: "R", totalVotes: 15508 },
      { county: "Scotts Bluff", margin: 26, marginParty: "R", totalVotes: 14935 },
      { county: "Adams", margin: 25, marginParty: "R", totalVotes: 14205 },
      { county: "Saunders", margin: 26, marginParty: "R", totalVotes: 13440 },
      { county: "Washington", margin: 26, marginParty: "R", totalVotes: 12436 },
      { county: "Gage", margin: 15, marginParty: "R", totalVotes: 10863 },
      { county: "Seward", margin: 28, marginParty: "R", totalVotes: 9165 },
      { county: "Dawson", margin: 32, marginParty: "R", totalVotes: 8415 },
      { county: "Otoe", margin: 16, marginParty: "R", totalVotes: 8118 },
      { county: "York", margin: 33, marginParty: "R", totalVotes: 6953 },
      { county: "Dakota", margin: 4, marginParty: "R", totalVotes: 5954 },
      { county: "Custer", margin: 51, marginParty: "R", totalVotes: 5856 },
      { county: "Saline", margin: 8, marginParty: "R", totalVotes: 5613 },
      { county: "Hamilton", margin: 45, marginParty: "R", totalVotes: 5509 },
      { county: "Holt", margin: 51, marginParty: "R", totalVotes: 5380 },
      { county: "Red Willow", margin: 72, marginParty: "R", totalVotes: 5264 },
      { county: "Phelps", margin: 53, marginParty: "R", totalVotes: 4939 },
      { county: "Cedar", margin: 52, marginParty: "R", totalVotes: 4872 },
      { county: "Box Butte", margin: 32, marginParty: "R", totalVotes: 4840 },
      { county: "Butler", margin: 43, marginParty: "R", totalVotes: 4519 },
      { county: "Cheyenne", margin: 43, marginParty: "R", totalVotes: 4456 },
      { county: "Cuming", margin: 43, marginParty: "R", totalVotes: 4403 },
      { county: "Knox", margin: 47, marginParty: "R", totalVotes: 4385 },
      { county: "Merrick", margin: 49, marginParty: "R", totalVotes: 4316 },
      { county: "Keith", margin: 43, marginParty: "R", totalVotes: 4148 },
      { county: "Wayne", margin: 28, marginParty: "R", totalVotes: 4057 },
      { county: "Pierce", margin: 51, marginParty: "R", totalVotes: 3870 },
      { county: "Richardson", margin: 21, marginParty: "R", totalVotes: 3852 },
      { county: "Dawes", margin: 30, marginParty: "R", totalVotes: 3834 },
      { county: "Jefferson", margin: 25, marginParty: "R", totalVotes: 3617 },
      { county: "Kearney", margin: 44, marginParty: "R", totalVotes: 3599 },
      { county: "Burt", margin: 22, marginParty: "R", totalVotes: 3595 },
      { county: "Howard", margin: 42, marginParty: "R", totalVotes: 3505 },
      { county: "Colfax", margin: 33, marginParty: "R", totalVotes: 3457 },
      { county: "Antelope", margin: 51, marginParty: "R", totalVotes: 3409 },
      { county: "Nemaha", margin: 19, marginParty: "R", totalVotes: 3375 },
      { county: "Clay", margin: 47, marginParty: "R", totalVotes: 3267 },
      { county: "Stanton", margin: 48, marginParty: "R", totalVotes: 3024 },
      { county: "Fillmore", margin: 34, marginParty: "R", totalVotes: 3002 },
      { county: "Boone", margin: 52, marginParty: "R", totalVotes: 3001 },
      { county: "Cherry", margin: 57, marginParty: "R", totalVotes: 2977 },
      { county: "Thayer", margin: 41, marginParty: "R", totalVotes: 2852 },
      { county: "Dixon", margin: 39, marginParty: "R", totalVotes: 2845 },
      { county: "Polk", margin: 45, marginParty: "R", totalVotes: 2827 },
      { county: "Sheridan", margin: 54, marginParty: "R", totalVotes: 2456 },
      { county: "Furnas", margin: 48, marginParty: "R", totalVotes: 2403 },
      { county: "Morrill", margin: 46, marginParty: "R", totalVotes: 2370 },
      { county: "Valley", margin: 46, marginParty: "R", totalVotes: 2277 },
      { county: "Nuckolls", margin: 41, marginParty: "R", totalVotes: 2217 },
      { county: "Johnson", margin: 14, marginParty: "R", totalVotes: 2131 },
      { county: "Thurston", margin: 7, marginParty: "I", totalVotes: 2043 },
      { county: "Chase", margin: 61, marginParty: "R", totalVotes: 1849 },
      { county: "Nance", margin: 37, marginParty: "R", totalVotes: 1819 },
      { county: "Harlan", margin: 53, marginParty: "R", totalVotes: 1788 },
      { county: "Webster", margin: 48, marginParty: "R", totalVotes: 1732 },
      { county: "Kimball", margin: 43, marginParty: "R", totalVotes: 1682 },
      { county: "Sherman", margin: 37, marginParty: "R", totalVotes: 1660 },
      { county: "Brown", margin: 53, marginParty: "R", totalVotes: 1625 },
      { county: "Franklin", margin: 52, marginParty: "R", totalVotes: 1585 },
      { county: "Perkins", margin: 53, marginParty: "R", totalVotes: 1426 },
      { county: "Hitchcock", margin: 51, marginParty: "R", totalVotes: 1420 },
      { county: "Frontier", margin: 52, marginParty: "R", totalVotes: 1391 },
      { county: "Pawnee", margin: 31, marginParty: "R", totalVotes: 1368 },
      { county: "Greeley", margin: 49, marginParty: "R", totalVotes: 1219 },
      { county: "Gosper", margin: 52, marginParty: "R", totalVotes: 1124 },
      { county: "Garden", margin: 51, marginParty: "R", totalVotes: 1104 },
      { county: "Boyd", margin: 79, marginParty: "R", totalVotes: 1061 },
      { county: "Deuel", margin: 45, marginParty: "R", totalVotes: 1000 },
      { county: "Garfield", margin: 59, marginParty: "R", totalVotes: 995 },
      { county: "Dundy", margin: 58, marginParty: "R", totalVotes: 914 },
      { county: "Rock", margin: 62, marginParty: "R", totalVotes: 825 },
      { county: "Sioux", margin: 58, marginParty: "R", totalVotes: 672 },
      { county: "Keya Paha", margin: 68, marginParty: "R", totalVotes: 535 },
      { county: "Hayes", margin: 77, marginParty: "R", totalVotes: 491 },
      { county: "Wheeler", margin: 59, marginParty: "R", totalVotes: 474 },
      { county: "Logan", margin: 63, marginParty: "R", totalVotes: 439 },
      { county: "Loup", margin: 57, marginParty: "R", totalVotes: 431 },
      { county: "Hooker", margin: 53, marginParty: "R", totalVotes: 422 },
      { county: "Banner", margin: 61, marginParty: "R", totalVotes: 384 },
      { county: "Thomas", margin: 57, marginParty: "R", totalVotes: 381 },
      { county: "Grant", margin: 79, marginParty: "R", totalVotes: 359 },
      { county: "Blaine", margin: 56, marginParty: "R", totalVotes: 291 },
      { county: "Arthur", margin: 67, marginParty: "R", totalVotes: 280 },
      { county: "McPherson", margin: 70, marginParty: "R", totalVotes: 279 }
    ]
  },

  // Arizona
  {
    state: "AZ",
    demCandidate: "Ruben Gallego",
    repCandidate: "Kari Lake",
    indCandidate: null,
    demVotes: 1676335,
    repVotes: 1595761,
    indVotes: 0,
    otherVotes: 75868,
    totalVotes: 3347964,
    winner: "D",
    incumbent: null,
    counties: [
      { county: "Maricopa", margin: 5, marginParty: "D", totalVotes: 2030083 },
      { county: "Pima", margin: 21, marginParty: "D", totalVotes: 505631 },
      { county: "Pinal", margin: 14, marginParty: "R", totalVotes: 206891 },
      { county: "Yavapai", margin: 28, marginParty: "R", totalVotes: 147832 },
      { county: "Mohave", margin: 49, marginParty: "R", totalVotes: 108470 },
      { county: "Coconino", margin: 26, marginParty: "D", totalVotes: 69470 },
      { county: "Yuma", margin: 10, marginParty: "R", totalVotes: 67102 },
      { county: "Cochise", margin: 17, marginParty: "R", totalVotes: 58093 },
      { county: "Navajo", margin: 10, marginParty: "R", totalVotes: 50469 },
      { county: "Apache", margin: 27, marginParty: "D", totalVotes: 31859 },
      { county: "Gila", margin: 30, marginParty: "R", totalVotes: 27327 },
      { county: "Santa Cruz", margin: 30, marginParty: "D", totalVotes: 18952 },
      { county: "Graham", margin: 41, marginParty: "R", totalVotes: 14993 },
      { county: "La Paz", margin: 36, marginParty: "R", totalVotes: 7509 },
      { county: "Greenlee", margin: 30, marginParty: "R", totalVotes: 3283 }
    ]
  },

  // Nevada
  {
    state: "NV",
    demCandidate: "Jacky Rosen",
    repCandidate: "Sam Brown",
    indCandidate: null,
    demVotes: 701105,
    repVotes: 677046,
    indVotes: 0,
    otherVotes: 86577,
    totalVotes: 1464728,
    winner: "D",
    incumbent: "D",
    counties: [
      { county: "Clark", margin: 7, marginParty: "D", totalVotes: 1014837 },
      { county: "Washoe", margin: 6, marginParty: "D", totalVotes: 261475 },
      { county: "Douglas", margin: 30, marginParty: "R", totalVotes: 35255 },
      { county: "Lyon", margin: 38, marginParty: "R", totalVotes: 33287 },
      { county: "Carson City", margin: 6, marginParty: "R", totalVotes: 30799 },
      { county: "Nye", margin: 36, marginParty: "R", totalVotes: 26843 },
      { county: "Elko", margin: 51, marginParty: "R", totalVotes: 22245 },
      { county: "Churchill", margin: 44, marginParty: "R", totalVotes: 13406 },
      { county: "Humboldt", margin: 46, marginParty: "R", totalVotes: 7968 },
      { county: "White Pine", margin: 53, marginParty: "R", totalVotes: 4334 },
      { county: "Storey", margin: 34, marginParty: "R", totalVotes: 3058 },
      { county: "Lander", margin: 51, marginParty: "R", totalVotes: 2711 },
      { county: "Lincoln", margin: 65, marginParty: "R", totalVotes: 2454 },
      { county: "Pershing", margin: 48, marginParty: "R", totalVotes: 2291 },
      { county: "Mineral", margin: 26, marginParty: "R", totalVotes: 2287 },
      { county: "Eureka", margin: 70, marginParty: "R", totalVotes: 1020 },
      { county: "Esmeralda", margin: 60, marginParty: "R", totalVotes: 458 }
    ]
  },

  // Maryland
  {
    state: "MD",
    demCandidate: "Angela Alsobrooks",
    repCandidate: "Larry Hogan",
    indCandidate: null,
    demVotes: 1650912,
    repVotes: 1294344,
    indVotes: 0,
    otherVotes: 69396,
    totalVotes: 3014652,
    winner: "D",
    incumbent: null,
    counties: [
      { county: "Montgomery", margin: 33, marginParty: "D", totalVotes: 516039 },
      { county: "Baltimore County", margin: 6, marginParty: "D", totalVotes: 410128 },
      { county: "Prince George's", margin: 67, marginParty: "D", totalVotes: 402039 },
      { county: "Anne Arundel", margin: 9, marginParty: "R", totalVotes: 309616 },
      { county: "Baltimore City", margin: 62, marginParty: "D", totalVotes: 229674 },
      { county: "Howard", margin: 15, marginParty: "D", totalVotes: 181413 },
      { county: "Frederick", margin: 11, marginParty: "R", totalVotes: 154340 },
      { county: "Harford", margin: 32, marginParty: "R", totalVotes: 148723 },
      { county: "Carroll", margin: 45, marginParty: "R", totalVotes: 101588 },
      { county: "Charles", margin: 28, marginParty: "D", totalVotes: 91629 },
      { county: "Washington", margin: 35, marginParty: "R", totalVotes: 71814 },
      { county: "St. Mary's", margin: 33, marginParty: "R", totalVotes: 58303 },
      { county: "Calvert", margin: 28, marginParty: "R", totalVotes: 53630 },
      { county: "Cecil", margin: 43, marginParty: "R", totalVotes: 51752 },
      { county: "Wicomico", margin: 22, marginParty: "R", totalVotes: 46347 },
      { county: "Worcester", margin: 42, marginParty: "R", totalVotes: 32467 },
      { county: "Queen Anne's", margin: 46, marginParty: "R", totalVotes: 32102 },
      { county: "Allegany", margin: 46, marginParty: "R", totalVotes: 31307 },
      { county: "Talbot", margin: 20, marginParty: "R", totalVotes: 22740 },
      { county: "Dorchester", margin: 26, marginParty: "R", totalVotes: 16584 },
      { county: "Caroline", margin: 48, marginParty: "R", totalVotes: 16076 },
      { county: "Garrett", margin: 62, marginParty: "R", totalVotes: 15438 },
      { county: "Kent", margin: 18, marginParty: "R", totalVotes: 11029 },
      { county: "Somerset", margin: 26, marginParty: "R", totalVotes: 9874 }
    ]
  }
];

// Helper functions
export const stateNames = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
  KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
  MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
  MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
  VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming'
};

export const getSenateTotals = (races = senateResults2024) => {
  return races.reduce((acc, race) => {
    acc.demVotes += race.demVotes;
    acc.repVotes += race.repVotes;
    acc.indVotes += race.indVotes || 0;
    acc.otherVotes += race.otherVotes;
    acc.totalVotes += race.totalVotes;
    acc.demSeats += race.winner === 'D' ? 1 : 0;
    acc.repSeats += race.winner === 'R' ? 1 : 0;
    acc.indSeats += race.winner === 'I' ? 1 : 0;
    return acc;
  }, { demVotes: 0, repVotes: 0, indVotes: 0, otherVotes: 0, totalVotes: 0, demSeats: 0, repSeats: 0, indSeats: 0 });
};

export const getWinnerInfo = (race) => {
  if (race.winner === 'D') {
    return {
      name: race.demCandidate,
      party: 'Democrat',
      votes: race.demVotes,
      pct: ((race.demVotes / race.totalVotes) * 100).toFixed(1)
    };
  } else if (race.winner === 'R') {
    return {
      name: race.repCandidate,
      party: 'Republican',
      votes: race.repVotes,
      pct: ((race.repVotes / race.totalVotes) * 100).toFixed(1)
    };
  } else if (race.winner === 'I') {
    return {
      name: race.indCandidate,
      party: 'Independent',
      votes: race.indVotes,
      pct: ((race.indVotes / race.totalVotes) * 100).toFixed(1)
    };
  }
};

export const getMargin = (race) => {
  const demPct = (race.demVotes / race.totalVotes) * 100;
  const repPct = (race.repVotes / race.totalVotes) * 100;
  const indPct = race.indVotes ? (race.indVotes / race.totalVotes) * 100 : 0;
  
  // Find the top two
  const results = [
    { party: 'D', pct: demPct },
    { party: 'R', pct: repPct },
    { party: 'I', pct: indPct }
  ].sort((a, b) => b.pct - a.pct);
  
  const margin = (results[0].pct - results[1].pct).toFixed(1);
  const winnerParty = results[0].party;
  
  const colors = { D: '#2563eb', R: '#dc2626', I: '#16a34a' };
  const labels = { D: 'D', R: 'R', I: 'I' };
  
  return {
    text: `${labels[winnerParty]}+${margin}%`,
    color: colors[winnerParty],
    party: winnerParty
  };
};